<!--
    La pagina para administrar Procesos
-->

<div class="page" id="process-defs-collection-page">
	<div class="action-bar dark-bg with-tabs">
			<div class="title">Procesos</div>
			<div class="tabs">
				<a class="tab selected" href="#procesos?estado=E">En edición</a>
				<a class="tab" href="#procesos?estado=A">Activos</a>
				<a class="tab" href="#procesos?estado=I">Inactivos</a>
				<a class="tab" href="#procesos?estado=X">Eliminados</a>
				<a class="tab" href="#procesos?estado=*">Todos</a>
			</div>
			<div class="actions-set">
				<a class="action-btn back" href="#home"></a>
				<a class="action-btn search" href="#"></a>
				<a class="action-btn add" href="#proceso?id=nuevo">Agregar un nuevo proceso</a>
				<a class="action-btn sos" href="#">SOS</a>
			</div>
	</div>
	<div class="content">
		<div class="container">
			<div class="section" id="procesos">
				<div class="list-content"></div>
			</div>
		</div>
	</div>
</div>


<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#process-defs-collection-page").ProcessDefsCollectionPage("#procesos") ;
  console.log("DONE: installed ProcessDefsCollectionPage to hash '#procesos'")
})
</script>
